import createModalModel, { prop } from './lib/create_modal_model';

export default createModalModel({
  modelName: 'AgentStatusReason',
  properties: { agentName: prop(String) },
});
